import { useEffect } from 'react';
import { loadScriptSecurely, executeScriptSecurely } from '@/utils/secureWeb3Provider';
import { getNonce } from '@/utils/nonce';

export const GoogleTag = ({ measurementId }: { measurementId: string }) => {
  useEffect(() => {
    // Use our secure script loading utilities instead of Helmet
    const initGoogleTag = async () => {
      try {
        // Load the external script with proper nonce
        await loadScriptSecurely(`https://www.googletagmanager.com/gtag/js?id=${measurementId}`);
        
        // Execute the inline initialization script with proper nonce
        const initScript = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${measurementId}');
        `;
        executeScriptSecurely(initScript);
      } catch (error) {
        console.error('Error initializing Google Tag Manager:', error);
      }
    };
    
    initGoogleTag();
  }, [measurementId]);
  
  return null;
};
